import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import HoverComponent from './HoverComponent';

import { GRID_ROW_COL_MAX_TEXT } from '../../constants';
import infoIcon from '../../images/announcement_icon.svg';
import GridInfoBox from './EnhancedGridFeature/GridInfoBox';

function selectInputText(element) {
  element.setSelectionRange(element.value.length, element.value.length);
}

export default class GenericTextareaEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: this.props.editing,
      text: this.props.text,
      regexUnmatched: false,
      minLength: this.props.minLength,
      stopEditingFlag: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.isInputValid = this.props.validate || this.isInputValid;
    if (this.props.editEnabled) {
      this.startEditing();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isTextChanged = nextProps.text !== this.props.text;
    const isEditingChanged = nextProps.editing !== this.props.editing;
    const nextState = {};
    if (isTextChanged) {
      nextState.text = nextProps.text;
    }
    if (isEditingChanged) {
      nextState.editing = nextProps.editing;
    }
    if (isTextChanged || isEditingChanged) {
      this.setState(nextState);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const inputElem = ReactDOM.findDOMNode(this.input);
    if (this.state.editing && !prevState.editing) {
      inputElem.focus();
      selectInputText(inputElem);
    } else if (this.state.editing && prevProps.text !== this.props.text
      && !this.state.regexUnmatched) {
      this.finishEditing();
    }
  }

  componentDidMount() {
    const inputElem = ReactDOM.findDOMNode(this.input);
    if (this.state.editing) {
      inputElem.focus();
      selectInputText(inputElem);
    }
  }

  startEditing = e => {
    if (!this.state.stopEditingFlag) {
      if (this.props.stopPropagation) {
        e.stopPropagation();
      }
      this.setState({ editing: true, text: this.props.fullText });
    }
  };

  isParenthesMatching = str => {
    const stack = [];

    const open = {
      '{': '}',
      '[': ']',
      '(': ')',
    };

    const closed = {
      '}': true,
      ']': true,
      ')': true,
    };

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (open[char]) {
        stack.push(char);
      } else if (closed[char]) {
        if (open[stack.pop()] !== char) return false;
      }
    }
    return stack.length === 0;
  }

  finishEditing = (e, eventName) => {
    const textNotChangedFlag = this.state.text.trim() === this.props.fullText.trim();

    if (textNotChangedFlag || this.isParenthesMatching(this.state.text)) {
      this.setState({ regexUnmatched: false, stopEditingFlag: false });
      if (
        this.isInputValid(this.state.text) &&
        this.props.fullText !== this.state.text
      ) {
        this.commitEditing();
      } else if (
        this.props.fullText === this.state.text ||
        !this.isInputValid(this.state.text)
      ) {
        this.cancelEditing();
      }
      this.props.resetSelectedIndex();
    } else if (eventName === 'blur') {
        this.cancelEditing();
      } else {
        this.setState({ regexUnmatched: true, stopEditingFlag: true });
        if (e) {
          e.stopPropagation();
        }
      }
  };

  cancelEditing = () => {
    this.setState({ editing: false, text: this.props.text, regexUnmatched: false, stopEditingFlag: false });
  };

  commitEditing = () => {
    this.setState({ editing: false, text: this.state.text });
    const newProp = {};
    newProp[this.props.paramName] = this.state.text;
    this.props.change(newProp);
  };

  clickWhenEditing = e => {
    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
  };

  isInputValid = text =>
    text.length >= this.state.minLength;

  keyDown = event => {
    if (event.keyCode === 13) {
      this.finishEditing(event);
    } else if (event.keyCode === 27) {
      this.cancelEditing();
    }
  };

  onBlur = e => {
    if (!this.state.regexUnmatched) {
      this.finishEditing(e, 'blur');
    } else {
      this.cancelEditing();
    }
  }

  textChanged = event => this.setState({ text: event.target.value.trim() });

  render() {
    if (this.props.isDisabled || (this.state.text === 'Total' && this.props.index === 0)) {
      const Element = this.props.element || this.props.staticElement;
      return (
        <Element className={this.props.className}>
          {this.state.text || this.props.placeholder}
        </Element>
      );
    }

    if (!this.state.editing) {
      const Element = this.props.element || this.props.staticElement;

      return (
        <Element
          className={this.props.className}
          onDoubleClick={this.startEditing}
          onClick={this.startEditing}
          tabIndex={this.props.tabIndex}
          style={{ outline: 'none' }}
        >
          {this.state.text || this.props.placeholder}
          {this.props.isLabelUpdated ? <sup>1</sup> : ''}
          {this.props.originalLabel && this.props.toggleLabel && this.props.originalLabel.length >=
            GRID_ROW_COL_MAX_TEXT ? '...' : ''}
          {this.props.showFootNoteIcon.length > 0 && <GridInfoBox
            Positions={['bottom', 'right']}
            InfoBoxButtonInner={<img
              src={infoIcon}
              alt="Footnote Icon" title="" />}
            Align="start"
            containerClassName="mrc-accredited-popover"
            btnWidth="20px"
            footNotes={this.props.showFootNoteIcon}
            footNoteList={this.props.crosstabFootNotes}
          />}
        </Element>
      );
    }

    const Element = this.props.element || this.props.editingElement;
    // if minHeight and maxHeight are available will try to set css height based on toggleLabel
    const height = this.props.toggleLabel ? this.props.maxHeight : this.props.minHeight;
    const textEditingElement = {
      onClick: this.clickWhenEditing,
      onKeyDown: this.keyDown,
      onBlur: this.onBlur,
      className: this.props.activeClassName,
      onChange: this.textChanged,
      style: { ...this.props.style, height },
      cols: this.props.cols,
      // change the size of the textarea if label full mode is on
      // also change the size based on length of text but not beyond a limit
      rows: this.props.toggleLabel ?
        Math.min(this.props.maxRows, Math.ceil(this.state.text.length / this.props.cols)) :
        this.props.minRows,
    };
    return (
      <HoverComponent
        isPopoverOpen={this.state.regexUnmatched}
        Element={Element}
        ref={node => (this.input = node)}
        textEditingElement={textEditingElement}
        text={this.state.text}
      />
    );
  }
}

GenericTextareaEdit.propTypes = {
  text: PropTypes.string.isRequired,
  fullText: PropTypes.string.isRequired,
  paramName: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  // onClick: PropTypes.func,
  element: PropTypes.element,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  validate: PropTypes.func,
  stopPropagation: PropTypes.func,
  style: PropTypes.shape({}),
  editingElement: PropTypes.string,
  staticElement: PropTypes.string,
  tabIndex: PropTypes.number,
  isDisabled: PropTypes.bool,
  editing: PropTypes.bool,
  cols: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  minHeight: PropTypes.string,
  maxHeight: PropTypes.string,
  originalLabel: PropTypes.string,
  isLabelUpdated: PropTypes.bool,
  toggleLabel: PropTypes.bool,
  editEnabled: PropTypes.bool,
  minLength: PropTypes.number,
  showFootNoteIcon: PropTypes.bool,
  crosstabFootNotes: PropTypes.shape({}),
  index: PropTypes.number
};

GenericTextareaEdit.defaultProps = {
  minLength: 0,
  editingElement: 'textarea',
  staticElement: 'span',
  tabIndex: 0,
  isDisabled: false,
  editing: false,
  editEnabled: false,
  showFootNoteIcon: false,
};
